import * as is from 'Services/Misc/is';

export const urlEncode = (url = '') => encodeURIComponent(url);
export const timecode  = val => {
  if(typeof val !== 'number') {
    return '00:00';
  } else {
    const minutes = Math.floor(val / 60),
          seconds = Math.floor(val % 60);

    return `${twoDigit(minutes)}:${twoDigit(seconds)}`;
  }
};
export const twoDigit  = (val = 0) => val > 9 ? val.toString() : `0${val}`;
export const timeCodeToSeconds = (timecode = '') => {
  const sections = timecode.split(/\:|\./);

  if(sections.length) {
    return (
      sections
        .reduce((seconds, val, index) => {
          let num = Number(val),
              sec = index === 0 ? 3600 : (index === 1) ? 60 : (index === 2) ? 1 : (index === 3) ? 0.001 : 0;
          
          if(!isNaN(num)) {
            seconds += num * sec;
          }

          return seconds;
        }, 0)
    );
  }

  return 0;
};

export const replaceMacros = (source, macros, startDelimeter = '[', endDelimeter = ']') => {
  return (
    Object
      .keys(macros)
      .reduce( (replaced, macro) => replaced.replace(`${startDelimeter}${macro}${endDelimeter}`, urlEncode(macros[macro])), source )
  )
};
export const cacheBusterMacro = () => ({
  CACHE_BUSTER: new Date().getTime()
});

export const objToQuery = (obj = {}) => {
  const query = is.obj(obj) ? Object.keys(obj).reduce((str, key) => str += `&${key}=${obj[key]}`, '') : '';

  if(query && query.length && query[0] === '&') {
    return query.slice(1);
  } else {
    return '';
  }
};


// WEBPACK FOOTER //
// ./src/Services/Misc/format.js